// This file is copied from https://github.com/GetStream/stream-chat-react/blob/master/src/components/MessageList/UnreadMessagesNotification.tsx
// with some modifications so that we can control the tranlsations (and to match our older stream library version)
// (stream does not currently support all of our langauges - see SOFTWARE-5782)

import { IconXmark } from "./CarbonStreamIcons";
import { useChannelActionContext } from "stream-chat-react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import React, { FunctionComponent } from "react";

export type UnreadMessagesNotificationProps = {
  /**
   * Configuration parameter to determine the message page size, when jumping to the first unread message.
   */
  queryMessageLimit?: number;
  /**
   * Configuration parameter to determine, whether the unread count is to be shown on the component. Enabled by default.
   */
  showCount?: boolean;
  /**
   * The count of unread messages to be displayed if enabled.
   */
  unreadCount?: number;
};

export const CarbonUnreadMessagesNotification: FunctionComponent<
  UnreadMessagesNotificationProps
> = ({
  queryMessageLimit,
  showCount = true,
  unreadCount,
}: UnreadMessagesNotificationProps) => {
  const { jumpToFirstUnreadMessage, markRead } = useChannelActionContext();
  const { t } = useTranslation();

  return (
    <div
      className={clsx("str-chat__unread-messages-notification", {
        "str-chat__unread-messages-notification--with-count":
          unreadCount && showCount,
      })}
      data-testid="unread-messages-notification"
    >
      <button onClick={() => jumpToFirstUnreadMessage(queryMessageLimit)}>
        {unreadCount && showCount
          ? t("components.Chat.unreadMessagesCountShort", {
              count: unreadCount,
            })
          : t("components.Chat.unreadMessagesShort")}
      </button>
      <button onClick={() => markRead()}>
        <IconXmark />
      </button>
    </div>
  );
};
